const state = {
  pushNotifications: []
};

export default state;
